"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatUnique = exports.stringifyValues = exports.entries = exports.keys = void 0;
exports.keys = function (obj) {
    return Object.keys(obj);
};
exports.entries = function (obj) {
    return Object.entries(obj);
};
exports.stringifyValues = function (obj) {
    return Object.fromEntries(exports.entries(obj)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, value.toString()];
    }));
};
exports.concatUnique = function (anArray, anotherArray) {
    return Array.from(new Set(anArray.concat(anotherArray)));
};
